<div [attr.dir]="textDirection">
  <button *ngFor="let shareConfig of shareConfigurations" mat-menu-item (click)="share(shareConfig)">
    <span class="odilo-icon" aria-hidden="true">{{shareConfig.iconLigature}}</span>
    {{shareConfig.text | translate}}
  </button>
  <button mat-menu-item (click)="copyLink()">
    <span class="odilo-icon" aria-hidden="true">link</span>
    {{'tooltip.copyLink' | translate}}
  </button>
</div>
